<template>
  <div class="box">
    <v-server-table 
      ref="datatable" 
      :url="api" 
      :name="tableName" 
      :columns="columns" 
      :options="options"/>

    <div 
      id="preset-reason-popup" 
      class="modal fade inactive" 
      data-backdrop="false">
      <div class="right w-xxl white b-l">
        <preset-reason-form 
          ref="form" 
          :preset-reason="presetReason"/>
      </div>
    </div>

  </div>
</template>

<script>
import Auth from '@js/plugins/auth';
import presetReasonForm from './presetReasonForm.vue';
import VuetableCheckbox from '../../../components/vuetable2/checkbox/state';

const TableName = 'VUETABLE_PRESETREASON';

export default {
    components: {
        presetReasonForm,
    },

    data() {
        var that = this;

        let canManageSettings = Auth.hasPermissionTo(
            'franchise_manage_preset_reasons',
        );

        let actionButtons = [
            {
                title: 'Create Preset Reason',
                action: () => {
                    this.showPopup(null);
                },
            },
        ];

        if (!canManageSettings) {
            actionButtons = [];
        }

        return {
            presetReason: null,
            tableName: TableName,
            api: Laroute.route('franchise.setting.presetreason.index'),
            columns: ['reason', 'type'],
            options: {
                checkbox: canManageSettings,
                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.setting.presetreason.delete',
                    ),
                    delete_title: 'Delete Preset Reason',
                },
                orderBy: { column: 'type', ascending: 1 },
                texts: {
                    count:
                        'Showing {from} to {to} of {count} records|{count} records|One record',
                    limit: 'Records per page :',
                    filterPlaceholder: 'Search presetReason',
                },
                csv_url: Laroute.route(
                    'franchise.setting.presetreason.exportAsFile',
                    { type: 'CSV' },
                ),
                pdf_url: Laroute.route(
                    'franchise.setting.presetreason.exportAsFile',
                    { type: 'PDF' },
                ),
                actionButtons: actionButtons,
                rowClassCallback: row => 'pointer',
                rowClickCallback: that.showPopup,
                templates: {
                    type: function(h, row) {
                        return require('./type.jsx')(h, row);
                    },
                },
            },
        };
    },
    computed: {
        searchQuery() {
            return this.$refs.datatable.query;
        },
    },

    watch: {
        activeOutlet: function() {
            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'outlet_id',
                value: this.activeOutlet,
            });
        },
    },

    created() {
        this.initPresetReason();
        this.$store.registerModule(
            `CHECKBOX_${TableName}`,
            $.extend(true, {}, VuetableCheckbox),
        );
    },

    methods: {
        initPresetReason() {
            this.presetReason = {
                id: 0,
                name: '',
                type: 0,
            };
        },

        getPresetReason(id) {
            var that = this;
            let api = Laroute.route('franchise.setting.presetreason.show', {
                id: id,
            });

            this.$http.get(api).then(response => {
                that.presetReason = response.data.data;
                that.showModal();
            });
        },

        showPopup(row) {
            if (row != null) {
                this.getPresetReason(row.id);
            } else {
                var that = this;
                this.initPresetReason();
                this.showModal();
            }

            this.$refs.form.clearErrorValidation();
        },

        modal(action) {
            $('#preset-reason-popup').modal(action);
        },

        refresh() {
            this.$store.commit(`${TableName}/SET_FILTER`, this.searchQuery);
        },

        showModal() {
            $('#preset-reason-popup').modal('show');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/presetreason/presetReasonDatatable.vue